export default __webpack_public_path__ + "static/media/cp1.4a6065b8.png";